module.exports = "https://www.gc-pro.gnp.com.mx/551b462e9ccd5629ecb47a8df2a97a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/smart-trip-bk.png
// module id = 1862
// module chunks = 0